(function () {
  'use strict';

  function initSwipe() {
    const cards = document.querySelectorAll('.product-card__media--hoverable');

    cards.forEach(function (card) {
      if (card.dataset.swipeInit === 'true') return;
      card.dataset.swipeInit = 'true';

      let startX = 0;
      let startY = 0;

      card.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
      }, { passive: true });

      card.addEventListener('touchend', function (e) {
        const diffX = e.changedTouches[0].clientX - startX;
        const diffY = e.changedTouches[0].clientY - startY;

        // Alleen horizontale beweging telt, drempel verlaagd naar 10px
        if (Math.abs(diffX) < Math.abs(diffY)) return;
        if (Math.abs(diffX) < 10) return;

        const isShowingSecond = card.dataset.swipeActive === 'true';
        const dots = card.querySelectorAll('.product-card__swipe-dot');

        if (diffX > 0 && !isShowingSecond) {
          card.classList.add('swipe--second');
          card.dataset.swipeActive = 'true';
          if (dots[0]) dots[0].classList.remove('product-card__swipe-dot--active');
          if (dots[1]) dots[1].classList.add('product-card__swipe-dot--active');
        } else if (diffX < 0 && isShowingSecond) {
          card.classList.remove('swipe--second');
          card.dataset.swipeActive = 'false';
          if (dots[0]) dots[0].classList.add('product-card__swipe-dot--active');
          if (dots[1]) dots[1].classList.remove('product-card__swipe-dot--active');
        }
      }, { passive: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSwipe);
  } else {
    initSwipe();
  }

  document.addEventListener('shopify:section:load', initSwipe);
  document.addEventListener('collection:rerender', initSwipe);
})();